import Swal from "sweetalert2";

const Toast = Swal.mixin({
  toast: true,
  position: "top-right",
  iconColor: "white",
  customClass: {
    popup: "colored-toast",
  },
  showConfirmButton: false,
  timer: 4500,
  timerProgressBar: true,
});

export function showSuccessToast(message) {
  Toast.fire({
    icon: "success",
    title: "Success",
    text: message,
  });
}

export function showinfoToast(message) {
  Toast.fire({
    icon: "info",
    title: "Success",
    text: message,
  });
}

export function showErrorToast(title, message) {
  Toast.fire({
    icon: "error",
    title: title,
    text: message,
  });
}

export function showAlert(title, text, icon) {
  Swal.fire({
    text: text,
    title: title,
    icon: icon,
  });
}

export function showConfirmAlert(title) {
  return new Promise((resolve, reject) => {
    Swal.fire({
      title: title,
      showCancelButton: true,
      confirmButtonText: "Yes, Delete",
    }).then((result) => {
      result.isConfirmed ? resolve() : reject();
    });
  });
}

//generics
export function showAddSuccessAlert() {
  Swal.fire({
    text: "You can see the resource in the list",
    title: "Resource has been created",
    icon: "success",
  });
}

export function showUpdateSuccessAlert() {
  Swal.fire({
    text: "You can see the resource updated in the list",
    title: "Resource has been updated",
    icon: "success",
  });
}
